import { VideoResultItem } from "../types";

import { Card, Heading, Link, Paragraph } from "@digdir/designsystemet-react";
import { PlayFillIcon } from "@navikt/aksel-icons";

const VideoCard = (props: VideoResultItem) => {
  const {
    videoId,
    heading,
    videoImageUrl,
    videoUrl,
    mainIntro,
    videoStartPageUrl,
  } = props;

  return (
    <Card className="flex flex-col items-center gap-5 rounded-none sm:flex-row videoCard">
      <Card.Block className="flex flex-col w-full gap-[7px] p-0">
        <Heading level={2}>
          <Link href={videoUrl} rel="noopener noreferrer">
            {heading}
          </Link>
        </Heading>
        {mainIntro && <Paragraph>{mainIntro}</Paragraph>}
      </Card.Block>
      <Card.Block className="videoImg">
        <PlayFillIcon aria-hidden="true" fontSize="3rem" />
        <img
          src={videoImageUrl}
          alt={heading}
          className="w-full object-cover"
        />
      </Card.Block>
    </Card>
  );
};

export default VideoCard;
